import DraftNumberInput from "../../../inputs/DraftNumberInput";
import ProductWidgetContainer from "./ProductWidgetContainer";

const OrchestratorProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: any) => {
  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <DraftNumberInput
        label="Robots"
        product={product}
        field="concurrentRobots"
        baselineProfile={baselineProfile}
        editable={editable}
        onProductChange={onProductChange}
      />
    </ProductWidgetContainer>
  );
};

export default OrchestratorProductWidget;
